import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const yammer_question: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg viewBox="0 0 240 240" aria-hidden="true" focusable="false" {...rest}>
      <path
        fill={iconColor}
        stroke={iconColor}
        d="M137.7 75c0 10.5-2.85 18-8.55 24s-14.4 10.5-24.45
        12v16.8H90.45V108c0-3 2.85-7.5 5.7-7.5 8.55-1.5 27.3-9 27.3-24 0-9-8.55-19.5-27.3-19.5-17.25
        0-27.3 18-28.65 25.5L56 75c1.45-10.5 15.7-31.5 41.5-31.5S137.7 63 137.7 75zm-47.25
        61.5h14.4v12h-14.4z"
      ></path>
      <path
        fill={iconColor}
        stroke={iconColor}
        d="M51.6 232.5V174C23 159 0 129 0 96 0 46.5 41.55 7.5
        94.65 7.5c51.6 0 94.65 39 94.65 88.5
        0 24-10.05 45-27.3 61.5S123.3 183 100.35 183zM94.65 21C50.25 21 12.9 54 12.9 96c0 28.5 18.6 55.5
        47.4 67.5L66 165v34.5l28.65-30h1.5c21.45 0 41.55-9 55.95-22.5a73.08 73.08 0 0 0 23-52.5C176.4 54
        139.2 21 94.65 21z"
      ></path>
      <path
        fill={iconColor}
        stroke={iconColor}
        d="M184.5 229.5L135 198l7.5-12 28.5 19.5 1.5-25.5
        4.5-1.5c30-12
        49.5-37.5 49.5-67.5 0-19.5-9-39-24-52.5l9-10.5c18 16.5 28.5 39 28.5 63 0 33-21 63-54 78z"
      ></path>
    </svg>
  );
};
